module.exports = __webpack_public_path__ + "img/YAROSL.b5b8be2e.png";